"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Search = _interopRequireDefault(require("@p24/icons/Search"));

function _default(palette) {
  return {
    appearance: _Search["default"],
    appearanceOpacity: 0.38,
    searchPaddingLeft: palette.gutter * 3 + 'px',
    searchPaddingRight: palette.gutter * 3 + 'px',
    searchPaddingTop: palette.gutter + 'px',
    searchPaddingBottom: palette.gutter + 'px',
    hoverAppearanceOpacity: 0.87,
    focusAppearanceOpacity: 1
  };
}